import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
//import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';

import * as adminComponents from './AdminComponents/state';
import * as users_data from './users/state';
import * as ventas from './AdminComponents/ventas/state';

// Root Reducer, needs a previous state and action
const rootReducer = combineReducers({
	...adminComponents,
	...users_data,
	...ventas
});

// Store
export const store = createStore(
	rootReducer,
	//initial state. thunk:async functions
	compose(
		applyMiddleware(thunk),
		window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
	)
);
